var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"product-icon",class:`product-icon--${_vm.product}`,attrs:{"src":_vm.iconSrc,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }